module.exports = "/_next/static/images/6d1a12dcef0beb3ba21c991454c02be6-Nubank_HickDuarte_58741_xs.jpg.webp";